<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">图像偏色处理（调整图像偏色：偏红、偏绿、偏蓝）</h1>
		
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKEyeSDKColorCast(float rRateValue, 
float gRateValue, float bRateValue)；</code></pre>

		</h4><h3 class="doc_main_h3">参数</h3>
		<p class="doc_main_p">（1）rRateValue：红色R值偏色率</p>
        <p class="doc_main_p">（2）gRateValue：绿色G值偏色率</p>
        <p class="doc_main_p">（3）bRateValue：蓝色B值偏色率</p>
        <p>（偏色率计算公式：当前图片合适的RGB值/255（float类型），如果某个颜色值不需改变，则传入1，默认值为1，则不对该颜色值做处理，R、G、B颜色范围值：0~255）</p>
        <h3 class="doc_main_h3">备注</h3>
        <p class="doc_main_p">如需使用该接口，请在SDK初始化后调用一次即可。如果图像不需要偏色处理，则不需要调用该接口。</p>
        <h3 class="doc_main_h3">示例代码</h3>
        <p class="doc_main_p">skEyeSDK.SKEyeSDKColorCast(1, (float)0.9, 1);</p>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	import SKEyeJson from '../../../components/SKEyeJson'
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'sk-eye-json':SKEyeJson,
		},
		data(){
			return{
				isPathData:['物体识别','SKEye-Android','图像偏色处理（调整图像偏色：偏红、偏绿、偏蓝）'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skeyeandroid/imageBias.vue